"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("./");
const react_2 = require("@osmosys/react");
const QueryDetailLayoutContext_1 = require("./QueryDetailLayoutContext");
const NavPills_1 = require("./NavPills");
function OsmosysResourcePage(_a) {
    var { children, getTitle, getSubTitle, headerColor, backgroundImage, getHeaderBody, paths, getNav } = _a, props = tslib_1.__rest(_a, ["children", "getTitle", "getSubTitle", "headerColor", "backgroundImage", "getHeaderBody", "paths", "getNav"]);
    const { query } = props, queryProps = tslib_1.__rest(props, ["query"]);
    const queryResult = react_hooks_1.useQuery(query, Object.assign({ 
        // fetchPolicy: 'cache-and-network',
        // fetchPolicy: 'cache-first',
        // notifyOnNetworkStatusChange: false,
        errorPolicy: 'all' }, queryProps));
    const dataLoaded = !!(queryResult.data && queryResult.data[paths.item]);
    // Get title
    const title = dataLoaded && getTitle && getTitle(queryResult.data);
    // Get nav
    const nav = dataLoaded && getNav && getNav(queryResult.data);
    // Get Subtitle
    const subTitle = dataLoaded && getSubTitle && getSubTitle(queryResult.data);
    const headerBody = dataLoaded && getHeaderBody && getHeaderBody(queryResult.data);
    if ((!dataLoaded && queryResult.loading) ||
        queryResult.error ||
        !dataLoaded) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Container, { tag: react_2.OsmosysDiv, osysName: "OsmosysResourcePage.Container", className: "text-center flex-col-centered h-100" },
                react_1.default.createElement(reactstrap_1.Row, null,
                    queryResult.error && (react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "Failed to load", size: "lg" }))),
                    queryResult.loading && (react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement(reusables_1.Loading, { spinner: true }))),
                    !dataLoaded && !queryResult.error && !queryResult.loading && (react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "Not found", size: "lg" })))),
                queryResult.error && (react_1.default.createElement(react_2.OsmosysErrorAlert, { retry: queryResult.refetch, 
                    // floatBottom
                    // hideWarningIcon
                    apolloError: queryResult.error })))));
    }
    return (react_1.default.createElement(QueryDetailLayoutContext_1.QueryDetailLayoutContext.Provider, { value: {
            queryResult,
        } },
        react_1.default.createElement(react_if_1.When, { condition: !!(title || subTitle || headerBody || nav) },
            react_1.default.createElement("div", { className: "rounded-lg shadow-sm m-2 border overflow-hidden bg-white" },
                react_1.default.createElement(react_2.OsmosysDiv, { osysName: "OsmosysResourcePage.OuterRow", className: classnames_1.default('query-detail-layout-header text-white text-center py-3 px-2', {
                        'bg-primary': !headerColor,
                        [`bg-${headerColor}`]: !!headerColor,
                    }), style: {
                        backgroundImage: backgroundImage
                            ? `url(${backgroundImage})`
                            : undefined,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    } },
                    react_1.default.createElement(reactstrap_1.Col, null,
                        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "OsmosysResourcePage.HeaderContainer" },
                            react_1.default.createElement(reactstrap_1.Row, null,
                                react_1.default.createElement(reactstrap_1.Col, null,
                                    react_1.default.createElement(react_if_1.When, { condition: !!title },
                                        react_1.default.createElement("h3", null, title)),
                                    react_1.default.createElement(react_if_1.When, { condition: !!subTitle },
                                        react_1.default.createElement("p", { className: "lead mb-0" }, subTitle)),
                                    react_1.default.createElement(react_if_1.When, { condition: !!headerBody },
                                        react_1.default.createElement("div", { className: "mt-2" }, headerBody))))))),
                react_1.default.createElement(react_if_1.When, { condition: !!nav }, () => (react_1.default.createElement("div", { className: "osmosys-resource-page-nav my-2 flex-grow-0 flex-shrink-1 flex-row-centered" },
                    react_1.default.createElement("div", { className: "" }, Array.isArray(nav) &&
                        nav[0] &&
                        !react_1.default.isValidElement(nav) ? (react_1.default.createElement(NavPills_1.NavPills, { tabs: nav })) : (nav))))))),
        children));
}
exports.OsmosysResourcePage = OsmosysResourcePage;
const QueryDetailLayoutInnerWrapper = ({ children, padding, }) => {
    return (react_1.default.createElement(reactstrap_1.Container, { className: "flex-full-col" },
        react_1.default.createElement(reactstrap_1.Row, { className: "flex-full-col" },
            react_1.default.createElement(reactstrap_1.Col, { className: classnames_1.default('flex-full-col', padding && 'p-3') }, children))));
};
function OsmosysResourcePageInner({ children, container, padding = true, }) {
    const { queryResult } = QueryDetailLayoutContext_1.useQueryDetailLayoutContext();
    const c = children && children(queryResult.data, queryResult);
    if (container !== false) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(QueryDetailLayoutInnerWrapper, { padding: padding }, c)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, c);
}
exports.OsmosysResourcePageInner = OsmosysResourcePageInner;
//# sourceMappingURL=OsmosysResourcePage.js.map